import { WorkBook } from 'xlsx-js-style';
import { ExcelTemplate } from '../../interfaces';
import * as XLSX from 'xlsx-js-style';
import { PortfolioComparison } from 'src/app/domain/portfolio-comparison/dto/PortfolioComparison';
import { getPreparedData } from './mapping';
import { fitToColumn } from '../financial-statement/utils';
import { setColumnWidth, withHeaderStyling } from '../../utils';

export class PeriodComparisonTemplate implements ExcelTemplate {
  export(data: PeriodComparisonExportData): WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(data);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }

  private getSheet(exportExcelData: PeriodComparisonExportData): XLSX.WorkSheet {
    const headersForLogic = this.getHeadersForLogic();
    const headerForDisplay = this.getHeadersForDisplay();
    const periods: PeriodComparisonExcel = {
      headerForLogic: headersForLogic,
      headerForDisplay,
    };
    const preparedData = getPreparedData(exportExcelData, periods);
    const whiteSpaceIndexes = [6, 12];
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      '!cols': fitToColumn(preparedData),
    };
    whiteSpaceIndexes.forEach((index) => setColumnWidth(sheet, index, 1.5));
    const smallColumns = [4, 5, 10, 11, 16, 17];
    smallColumns.forEach((index) => setColumnWidth(sheet, index, 7));
    return withHeaderStyling(sheet);
  }

  private getHeadersForLogic(): string[] {
    return ['Company', 'Investment(1)', 'Fair value(1)', 'Gain/(Loss)(1)', 'Multiple(1)', 'Holding(1)', 'empty(1)',
      'Investment', 'Fair value', 'Gain/(Loss)', 'Multiple', 'Holding', 'empty(2)',
      'Investment(2)', 'Fair value(2)', 'Gain/(Loss)(2)', 'Multiple(2)', 'Holding(2)'];
  }

  private getHeadersForDisplay(): string[] {
    return ['Company', 'Investment', 'Fair value', 'Gain/(Loss)', 'Multiple', 'Holding', '',
      'Investment', 'Fair value', 'Gain/(Loss)', 'Multiple', 'Holding', '',
      'Investment', 'Fair value', 'Gain/(Loss)', 'Multiple', 'Holding'];
  }
}

export interface PeriodComparisonExcel {
  headerForLogic: string[];
  headerForDisplay: string[];
}

export interface PeriodComparisonExportData {
  active: PortfolioComparison[];
  sold: PortfolioComparison[];
}
